export default "data:image/webp;base64,UklGRjQAAABXRUJQVlA4TCcAAAAvJ8AEACDStpE/iZNzNgFHAoEkf5QlFwgkjEHPdf8nALq1zxb02wMA"